(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .controller('CertificadoDeEstudiosController', CertificadoDeEstudiosController);

    CertificadoDeEstudiosController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Documento'];

    function CertificadoDeEstudiosController($scope, $rootScope, $stateParams, previousState, entity, Documento) {
        var vm = this;

        vm.dto = entity;
        vm.dto.dom = jsonSort(vm.dto.dom);
        vm.previousState = previousState.name;
        
        vm.isString = isString;
        vm.isArray = isArray;
        vm.getEtiqueta = getEtiqueta;
        
        function isString(json) {
            var temp = angular.copy(json);
            return angular.isString(temp) || angular.isNumber(temp);
        }
        
        function isArray(json){
            var temp = angular.copy(json);
            return angular.isArray(temp);
        }
        
        function jsonSort(o){
            if (Array.isArray(o)) {
                return o.sort().map(jsonSort);
            } else if (isObject(o)) {
                return Object
                    .keys(o)
                .sort()
                .reverse()
                    .reduce(function(a, k) {
                        a[k] = jsonSort(o[k]);
                        return a;
                    }, {});
                }
            return o;
        }
        
        function getEtiqueta(key,json){
        	if(key=='Firmante'){
        		for(var k in json){
        			if(k=='cargo')
        				return json[k];
        		}		
        	} else if (key=='Asignatura'){
        		for(var k in json){
        			if(k=='nombre')
        				return json[k];
        		}	
        	}
        	return k;
        }
        
        function isObject(v) {
            return '[object Object]' === Object.prototype.toString.call(v);
        };
    }
})();